//****Librarys ****//
import { DefaultButton, FontIcon, Label, mergeStyles, TeachingBubble } from '@fluentui/react';
import React, { useState, useEffect, useContext } from 'react';
import { useBoolean, useId } from '@fluentui/react-hooks';
import LenguajeContext from '../../../context/Lenguaje/lenguajeContext';
//*****Componnents*****//

//**Methods**//

/**
 *@author Sebastian Ocampo(14-05-2022)
 *@version 1.0
 *@lastCommit
 */

const InputFile = (props) => {
  
  /************************
   * @arguments
   ************************/
  const [stateType, setStateType] = useState(true);
  const buttonId = useId('targetButton');
  const [teachingBubbleVisible, { toggle: toggleTeachingBubbleVisible }] = useBoolean(true);
  const [count, setCount] = useState(0)
  const [score, setScore] = useState(1)
  const [unfit, setUnfit]= useState(false) 
  const [controlsPage, setControlsPage] = useState({});
  const {getLenguaje, stateLanguage} = useContext(LenguajeContext);
  const [entenD, setEntenD] = useState ('')
  const [entenA,setEntenA] = useState ('')
  const [entenB,setEntenB]  = useState ('')
  const [bot, setBot] = useState(false)
  const [messageError, setMessageError] = useState(false)
  const [txtValue, setTxtValue] = useState('')
  const [waitInput, setWaitInput] = useState(false);
  /************************
   * @methods
   ************************/

  useEffect(() => {
  
    if (props.listPolicies) {
      if (score ==props.listPolicies.length) {
        setBot(false)
      }else{
        setBot(true)
      }
    }
    
  if(score < 1 || score > (props.listPolicies ? props.listPolicies[score]:"")){
    setScore(1)
    setBot(true)
  }
  }, [score])
  
   const iconClass = mergeStyles({
    fontSize: 8,
    height: 8,
    width: 8,
    margin: '0',
    position: 'absolute',
    color: 'var(--color-primary)' 
  });

  useEffect(async() => {
    let controlsPage = {};
    if (stateLanguage.lenguaje !=0) {
        stateLanguage.lenguaje.map((pass) => {
            if ( pass.path == 'controls' || pass.path == 'change-password' || pass.path == 'associate-security-questions')  {
              pass.webcontrolspages.map((data) => {
                controlsPage[data.idHtml] = data.languagewebcontrols[0];
              })  
            }              
        })       
        setEntenD(controlsPage?.lblUnderstood?.value)
        setEntenA(controlsPage?.lblPrevious?.value)
        setEntenB(controlsPage?.smtNext?.value)   
      setControlsPage(controlsPage)
    }
  }, [stateLanguage])
  
  /************************
   * @hooks
   ************************/
  useEffect(() => {
    
  }, [controlsPage])
  
   const PrimaryButtonProps= React.useMemo( 
    () => ({
      children: entenA,
      onClick: ()=>{setScore(score-1);},
    }),
  );
   const dismissButtonProps = React.useMemo(
    () => ({
      children: entenD,
      onClick:()=>{toggleTeachingBubbleVisible();props.setDisable(false)},
    }),
    [toggleTeachingBubbleVisible,entenD],
  );
  const SecondaryButtonProps = React.useMemo(
    () => ({
      children: entenB,
      onClick: ()=>{setScore(score+1);},
    }),
    
  );

  const limitTxt = (e)=>{
    let newValue = props.withOutSpace?e.target.value.trim():e.target.value
    if(props.maxLength){
      if (newValue.length > props.maxLength) {
        // props.onMessage(true)
        setMessageError(true)
      }else if(newValue.length == props.maxLength){
        setTxtValue(newValue.slice(0, props.maxLength));
        // props.onMessage(true)
        setMessageError(true)
      }else{
        setTxtValue(newValue.slice(0, props.maxLength));
        // props.onMessage(false)
        setMessageError(false)
      }
    }else{
      setTxtValue(newValue)
    }
  }

  const validateTxt = ()=>{
    if(props.id !== undefined){
      let input = document.getElementById("input" + props.id);
      if(input !== null){
        if (input.value.length < props.min || input.value.length > props.max) {
          input.setCustomValidity(controlsPage?.txtAnswer?.infoMessage);
        } else {
          input.setCustomValidity("");
        }
      }
    }
  }
 
  const firstInfo = () =>{
    if (count === 0 && props.politics) {
       // toggleTeachingBubbleVisible()
      setCount(1)
    }
  }
  
  useEffect(() => {
    if(teachingBubbleVisible == false){
      setScore(0)
    }
    
  }, [teachingBubbleVisible])

  useEffect(() => {
    setTimeout(() => {
     setWaitInput(true)
    }, 2500);
  }, [])


  const renderPolicyMethod = window.__RUNTIME_CONFIG__.RENDER_POLICY_METHOD || 'method1';

  const renderMethod1 = () => {
    return (
      <TeachingBubble
        target={`#${buttonId}`}
        primaryButtonProps={score != 1 ? PrimaryButtonProps : ''}
        secondaryButtonProps={bot ? SecondaryButtonProps : dismissButtonProps}
        footerContent={`${score} ${controlsPage?.lblOf?.value} ${props.listPolicies.length}`}
        headline={controlsPage.lblPasswordPolicies?.value}
        className="teching-bubble"
        calloutProps={{
          preventDismissOnLostFocus: true,
        }}
      >
        <ul className="polits">
          <li>{props.listPolicies[(score === props.listPolicies.length ? 0 : score)].description}</li>
          {props.listPolicies[(score === props.listPolicies.length ? 0 : score)].values.map((item, index) => (
            <a key={index}>{item.value === '' ? "" : `${item.value}, `}</a>
          ))}
        </ul>
      </TeachingBubble>
    );
  };

  const renderMethod2 = () => {
    return (
      <TeachingBubble
        elementToFocusOnDismiss={true}
        target={`#${buttonId}`}
        primaryButtonProps={dismissButtonProps}
        headline={controlsPage.lblPasswordPolicies?.value}
        className="teching-bubble"
        calloutProps={{
          preventDismissOnLostFocus: true,
        }}
      >
        {props.listPolicies && props.listPolicies.length > 0 ? (
          <ul className="polits">
            {props.listPolicies.map((policy, index) => {
              let valuepolicies = "";
              const ultiPos = policy.values.length - 1;

              policy.values.forEach((value, i) => {
                if (value.idSecurityPolicyType !== 6 && value.idSecurityPolicyType !== 5) {
                  if (i === ultiPos) {
                    valuepolicies += value.value;
                  } else {
                    valuepolicies += value.value !== '' ? value.value + ", " : '';
                  }
                }
              });

              return (
                <div style={{ marginBottom: "15px" }} key={index}>
                  <li>{policy.description}</li>
                  <a>{valuepolicies}</a>
                </div>
              );
            })}
          </ul>
        ) : (
          <p>Políticas no disponibles</p>
        )}
      </TeachingBubble>
    );
  };


  /************************
   * @resturns
   ************************/
    if (props.type == "password") {
    return (
      <>
        <div className={`inputFile--container ${props.style}`}>
          <div className="est">
            {props.label && (
              <div className="content">
                <Label>
                  <div style={{position: "relative"}}>
                    <span>{props.label}</span>
                    {props.isRequired || props.required ? (
                      <FontIcon aria-label="requerido" iconName="SkypeCircleCheck" className={iconClass} />
                    ) : (
                      ''
                    )}
                  </div>
                </Label>
              </div>
            )}

            {props.politics && (
              <div className="content">
                <a id={buttonId} onClick={toggleTeachingBubbleVisible} className="politics">
                  {props.politics}
                </a>
              </div>
            )}
          </div>
          <div className="inputFielt--container-input">
            <input
              id={"input" + props.id}
              onClick={firstInfo}
              name={props.name}
              type={stateType ? "password" : "text"}
              placeholder={props.placeholder}
              disabled={props.disable ? true : false}
              autoComplete="off"
              onChange={(e)=>{props.onChange(e);limitTxt(e)}}
              defaultValue={props.defaultValue}
              required
              maxLength={props.max}
              minLength={props.min}
              value={txtValue}
              oninput={validateTxt()}
            />
            {props.listPolicies && props.listPolicies.length > 0 && waitInput && teachingBubbleVisible && (
              renderPolicyMethod === 'method1' ? renderMethod1() : renderMethod2()
            )}

            {messageError && props.msgError && (
              <div className="message-error">
                <p className="paragraf-error">{props.msgError}</p>
              </div>
            )}

            <span
              onClick={() => {
                stateType ? setStateType(false) : setStateType(true);
              }}
            >
              <FontIcon aria-label="ChevronLeftSmall" iconName={stateType ? 'RedEye' : 'VisuallyImpaired'} />
            </span>
          </div>
        </div>
      </>
    );
  } else if (props.type != "password") {
    if (props.required == true) {
      return (
        <>
          <div className={`inputFile--container ${props.style}`}>
            {props.label ? <Label>{props.label ? <div style={{position: "relative"}}> <span>{props.label}</span>{props.isRequired || props.required ? <FontIcon aria-label="requerido" iconName="SkypeCircleCheck" className={iconClass} /> : ''} </div> : ""}</Label> : undefined}
            <input
              name={props.name}
              type={props.type}
              placeholder={props.placeholder}
              disabled={props.disable ? true : false}
              autoComplete="off"
              onChange={(e)=>{props.onChange(e);limitTxt(e)}}
              defaultValue={props.defaultValue}
              maxLength={props.maxLength}
              minLength={props.minLength}
              required
            />
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className={`inputFile--container ${props.style}`}>
            { <Label>{props.label}</Label> }
            <input
              name={props.name}
              type={props.type}
              placeholder={props.placeholder}
              disabled={props.disable ? true : false}
              autoComplete="off"
              onChange={props.onChange}
              defaultValue={props.defaultValue}
              maxLength={props.maxLength}
              minLength={props.minLength}
            />
          </div>
        </>
      );
    }
  }
};

export default InputFile;